import {
  Button,
  ComponentMultiStyleConfig,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";

export type CMModalOptionsCancelProps = {
  isOpen?: boolean;
  labelHeader?: string;
  labelBody?: string;

  /**
   * 確定ボタンの表示に使用
   */
  labelSubmitButton?: string;
  submitButtonColorScheme?: string;

  /**
   * キャンセルボタンの表示に使用
   */
  labelCancelButton?: string;
  CancelButtonColorScheme?: string;

  /**
   * 確定したときのコールバック。
   */
  onSubmit?: () => void;

  /**
   * キャンセルしたときのコールバック。
   */
  onCancel?: () => void;
} & ComponentStyleProps;

/**
 * キャンセル可アラートモーダルを表示するコンポーネント
 */
export const CMModalOptionsCancel = ({
  isOpen = false,
  labelHeader,
  labelBody,
  labelSubmitButton,
  submitButtonColorScheme = "teal",

  labelCancelButton,
  CancelButtonColorScheme = "gray",

  onSubmit,
  onCancel,

  sx,
  ...rest
}: CMModalOptionsCancelProps) => {
  const styles = useMultiStyleConfig("CMModalOptionsCancelStyles");

  /**
   * 確定ボタン押下時の処理
   */
  const _onSubmit = () => {
    onSubmit?.();
    // モーダルを閉じる
    onCancel?.();
  };
  const _onCancel = () => {
    // モーダルを閉じる
    onCancel?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={_onCancel}>
      <ModalOverlay />
      <ModalContent sx={{ ...styles.container, ...sx }} {...rest}>
        <ModalHeader>{labelHeader}</ModalHeader>
        <ModalBody>{labelBody}</ModalBody>

        <ModalFooter sx={styles.modalFooter}>
          <Button
            colorScheme={submitButtonColorScheme}
            onClick={_onSubmit}
            sx={styles.submitButton}
          >
            <Text sx={styles.labelSubmitButton}>{labelSubmitButton}</Text>
          </Button>
          <Button
            colorScheme={CancelButtonColorScheme}
            onClick={_onCancel}
            sx={styles.cancelButton}
          >
            <Text sx={styles.labelCancelButton}>{labelCancelButton}</Text>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const CMModalOptionsCancelStyles: ComponentMultiStyleConfig = {
  parts: [
    "container",
    "modalFooter",
    "submitButton",
    "labelSubmitButton",
    "cancelButton",
    "labelCancelButton",
  ],
  baseStyle: {
    container: {},
    modalFooter: {
      w: "100%",
    },
    submitButton: { maxW: "40%" },
    labelSubmitButton: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
    cancelButton: { maxW: "40%", ml: "2" },
    labelCancelButton: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
  },
};
